import React from 'react'
import { Switch } from '@headlessui/react'
import classNames from "classnames";

const classes = {
    switch: classNames(
        "flex-shrink-0 group relative rounded-full inline-flex items-center justify-center h-5 w-10 cursor-pointer focus:outline-none",
//        "focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    ),
    track: enabled => classNames([
        enabled ? 'bg-indigo-600' : 'bg-gray-200',
        'pointer-events-none absolute h-4 w-9 mx-auto rounded-full transition-colors ease-in-out duration-200'
    ]),
    control: enabled => classNames([
        enabled ? 'translate-x-5' : 'translate-x-0',
        'pointer-events-none absolute left-0 inline-block h-5 w-5 border border-gray-200 rounded-full bg-white shadow transform ring-0 transition-transform ease-in-out duration-200'
    ]),
    label: "text-sm font-medium cursor-pointer select-none"
};

export default function Toggle({label, enabled, onChange}) {
    return (
        <Switch.Group as="div" className="flex items-center">
            <Switch checked={enabled} onChange={onChange} className={classes.switch}>
                <span className="sr-only">Use setting</span>
                <span aria-hidden="true" className="pointer-events-none absolute w-full h-full rounded-md" />
                <span aria-hidden="true" className={classes.track(enabled)} />
                <span aria-hidden="true" className={classes.control(enabled)} />
            </Switch>
            <Switch.Label as="span" className="ml-3">
                <span className={classes.label}>{label}</span>
            </Switch.Label>
        </Switch.Group>
    )
}
